/**
 * Created by Ammar Raufi on 1/6/2018.
 */
export const MineClasses = {
  unClicked: 'square unclicked',
  clickedWithMine: 'square mine',
  clickedWithMineLost: 'square mine-lost',
  clickedWithNoMine: 'square nomine',
  clickedAndGameOver: 'square winner',
  marked: 'square marked',
  markedWrong: 'square marked-wrong'
};



// WEBPACK FOOTER //
// ./src/app/minesweeper/constants/MineClasses.ts